import React from 'react'

const orderedSlineIds = [
	"3h87tdtkyZaM0ZzeAXpM9Y",
	"5DvKfb4YHmK2eO2J2TaTRZ",
	"1ZDcdWmZ0Aom3fQkkIRdCn",
	"4149icRZvvCBDsV190mY6z",
]

import Layout from '../components/layout'
import Meta from '../components/meta'
import tw, { styled, css } from 'twin.macro'
import { navigate, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import '../components/fonts/flexo.css'

const RoundedContainer = styled.div`
	border-radius: 40px;
	overflow: hidden;
`

const compareTableRowData = [
	{
		title: 'Maximum Pool Length',
		items: ['Up to 10 m', 'Up to 12 m', 'Up to 15 m'],
	},
	{
		title: 'Cleaning Coverage',
		items: [
			'Floor, walls, waterline, sun ledges & steps (min 30 cm)',
			'Floor, walls, waterline, sun ledges & steps (min 30 cm)',
			'Floor, walls, waterline, sun ledges & steps (min 30 cm)',
		],
	},
	{
		title: 'Cleaning Cycle',
		items: [
			'2.5 hours',
			'1 / 2 / 2.5 / 3 hours',
			'1 / 2 / 2.5 / 3 hours',
		],
	},
	{
		title: 'App Connectivity',
		items: [
			'✗',
			'MyDolphin™ Plus app',
			'MyDolphin™ Plus app'
		],
	},
	{
		title: 'Filter',
		items: [
			'Fine Filter Basket',
			'Interchangeable Fine & Ultra-Fine Filters',
			'Multi-Layer Filtration'
		],
	},
	{
		title: 'Warranty',
		items: ['2 years', '2 years', '3 years'],
	},
]

const CompareTableRow = ({ title, items }) => {
	return (
		<tr css={[tw`text-sm divide-x-2 divide-white border-b-2 border-white`]}>
			<td css={[tw`bg-blue-500 text-white font-bold py-4 px-3 text-center w-1/4 text-base md:text-lg`]}>{title}</td>
			{items.map((item, i) => {
				return (
					<td key={i} css={[tw`bg-gray-100 py-4 px-3 text-center`]}>
						{item}
					</td>
				)
			})}
		</tr>
	)
}

const SLinePoolCleaner = props => {
	const {
		SLineHeroBanner,
		SLineHeroBannerText,
		WhyChooseSLine01,
		SlineGridImages,
		SLine1000Asset,
		SLine2000Asset,
		SLine3000Asset,
		SLine1000TableAsset,
		SLine2000TableAsset,
		SLine3000TableAsset,
		SLineFeatureAsset1,
		SLineFeatureAsset2,
		SLineFeatureAsset3,
		SLineS3000Logo,
		SLineS2000Logo,
		SLineS1000Logo,
		SLineLogoTagline
	} = props.data

	const orderedSlineGridImages = orderedSlineIds.map(id =>
		SlineGridImages.nodes.find(node => node.contentful_id === id)
	).filter(Boolean)

	return (
		<div>
			<Layout>
				<Meta
					title="Dolphin S Line Robotic Pool Cleaners"
					keywords={[
						'pool cleaner',
						'robotic pool cleaner',
						'cordless pool cleaner',
						'pool vacuum'
					]}
					description="Dolphin S Line robotic pool cleaners by Maytronics take the hard work out of pool maintenance. Designed to adapt to different pool shapes and surfaces, they deliver efficient cleaning and outstanding results in residential pools."
				/>

				{/* Hero Section */}
				<div css={[tw`relative w-full overflow-hidden`, { height: 'clamp(220px, 30vw + 80px, 600px)' }]}>
					<Img
						fluid={SLineHeroBanner.nodes[0].fluid}
						alt={SLineHeroBanner.nodes[0].alt}
						style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
						imgStyle={{ objectFit: 'cover', objectPosition: 'center' }}
					/>

					{/* Hero Content Overlay - Left Aligned */}
					<div css={[
						tw`absolute inset-y-0 left-6 md:left-28 lg:left-40 flex flex-col justify-center items-start gap-1`
					]}>
						<Img
							{...SLineHeroBannerText.nodes[0]}
							loading="lazy"
							css={[tw`w-[30rem] sm:w-96 md:w-[36rem] lg:w-[46rem]`]}
						/>
						<div css={[tw`flex gap-3`]}>
							<button
								css={[
									tw`px-6 py-4 bg-transparent text-white font-bold rounded-full border border-white hover:bg-white hover:text-black transition-colors duration-200 shadow-lg whitespace-nowrap text-lg`,
								]}
								onClick={() => navigate('/dolphin/s-line')}
							>
								Buy Now
							</button>
							<button
								css={[
									tw`px-6 py-4 bg-transparent text-white font-bold rounded-full border border-white hover:bg-white hover:text-black transition-colors duration-200 shadow-lg whitespace-nowrap text-lg`,
								]}
								onClick={() => navigate('/book-a-demo')}
							>
								Book a Demo
							</button>
						</div>
					</div>
				</div>


				{/* Why Choose Dolphin S Line section */}
				<div
					css={[
						tw`text-center px-4 pt-12 pb-2 md:pt-16 md:pb-3 lg:pt-20 lg:pb-4 mx-auto max-w-screen-lg w-full`,
					]}
				>
					<h1 css={[ tw`text-lg lg:text-[1.75rem] xl:text-[2rem] leading-tight text-black mb-6 md:mb-8`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
						<span css={[{ fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
							Where Proven Reliability Meets Next-Gen Convenience
						</span>
						<br />
					</h1>
					<p
						css={[tw`text-sm lg:text-base xl:text-lg leading-tight text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}
					>
						The <strong>Dolphin S Line </strong> range delivers dependable, high-performance cleaning across pools of all shapes and sizes. Designed to reach every corner, each model covers floors, walls, steps, and sun-ledges as shallow as 30 cm - ensuring even the toughest spots stay spotless. With intelligent Maze navigation and superior filtration, the <strong>S Line </strong>provides consistent, reliable results all year round.
					</p>

					<p
						css={[
							tw`mt-6 text-sm lg:text-base xl:text-lg leading-tight text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important' },
						]}
					>
						Reliable, efficient and easy to use, the <strong> Dolphin S Line</strong> makes pool care effortless.
					</p>
				</div>

				{/* Image section - full width */}
				<RoundedContainer css={[tw`text-center mt-10 max-w-screen-xl w-full mx-auto px-4 md:px-8`]}>
					<Img
						{...WhyChooseSLine01.nodes[0]}
						loading="lazy"
						css={[tw`w-full mx-auto`]}
					/>
				</RoundedContainer>

				<div
					css={[
						tw`text-center px-4 pt-12 pb-10 md:pt-16 md:pb-12 lg:pt-20 lg:pb-16 mx-auto max-w-screen-lg w-full`,
					]}
				>
					<h1 css={[tw`text-lg lg:text-[1.75rem] xl:text-[2rem] leading-tight text-black mb-6 md:mb-8`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
						<span css={[{ fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
							Reaches Every Part of Your Pool
						</span>
					</h1>
					<p
						css={[
							tw`text-sm lg:text-base xl:text-lg leading-tight text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important' },
						]}
					>
						As you move through the range, added convenience features include custom cleaning modes, app connectivity and interchangeable filters to adapt to changing pool conditions. The S 3000 offers powerful multi-layer filtration to capture all levels of dirt and debris, a pick-up mode and a storage caddy and cover.
					</p>
				</div>


				{/* S Line Difference Images */}
				<section css={tw`py-8 md:py-10 max-w-screen-xl mx-auto px-8`}>
					<div css={tw`grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8`}>
						{orderedSlineGridImages.map((item, index) => (
							<div key={item.contentful_id ?? index} css={tw`flex flex-col items-center`}>
								<div css={tw`w-full relative overflow-hidden rounded-lg`}>
									<Img
										fluid={item.fluid}
										alt={item.title}
										css={tw`w-full h-full object-cover`}
									/>
								</div>
								<h2 css={[tw`my-4 text-center text-black leading-none text-base md:text-lg lg:text-xl xl:text-xl`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
									{item.title}
								</h2>
								<p css={[tw`text-base md:text-lg lg:text-lg xl:text-lg text-center text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
									{item.description}
								</p>
							</div>
						))}
					</div>
				</section>

				{/* Meet the Dolphin S Line */}
				<div css={tw`max-w-screen-lg py-5 md:py-10 px-8 md:px-16 mx-auto w-full text-center flex flex-col gap-5 text-lg`} >
					<h1 css={[tw`text-lg lg:text-[2rem] xl:text-[2.5rem] leading-tight text-black`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
						Meet the Dolphin S Line
					</h1>
				</div>

				{/* Meet the S Line Range section */}
				<div css={[tw`text-center px-8 pb-2 md:pb-3 lg:pb-4 mx-auto max-w-screen-lg w-full`]}>
					{/* S 3000 Grid */}
					<div css={[tw`grid md:grid-cols-2 gap-x-8 gap-y-6 md:gap-x-10 md:gap-y-14 lg:gap-x-12 lg:gap-y-16 max-w-6xl mx-auto items-stretch`]}>
						{/* S 3000 Content */}
						<div css={[tw`bg-white rounded-lg items-start text-center md:text-left`]}>
							<div css={[tw`block md:hidden rounded-[24px] overflow-hidden mb-4`]}>
								<Img
									{...SLine3000Asset.nodes[0]}
									loading="lazy"
									css={[tw`w-full h-full object-cover rounded-[24px]`]}
								/>
							</div>
							<div tw="flex justify-center md:justify-start mb-3">
								<img
									src={SLineS3000Logo.nodes[0].fluid.src}
									tw="w-auto h-full max-h-8 sm:max-h-10 md:max-h-12 lg:max-h-16 xl:max-h-20"
								/>
							</div>
							<p css={[tw`text-base md:text-lg lg:text-xl md:italic mt-3 mb-3 text-[#58C7DE]`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
								Best for full-featured performance
							</p>
							<ul css={[tw`list-disc list-outside text-sm md:text-base lg:text-lg text-black text-left space-y-1.5 mx-auto md:mx-0`,
								{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 400, lineHeight: 1.1, paddingLeft: '1.25rem' }]}>
								<li>MyDolphin™ Plus app control</li>
								<li>Covers the Entire Pool - Floor, Walls, Waterline, Steps and Sun Ledge (min 30 cm)</li>
								<li>6 Advanced Cleaning Modes: Regular, Fast Mode, Floor Only, Ultra Clean, Waterline Only & Full Coverage</li>
								<li>Multi-layer filter basket</li>
								<li>Pick-Up Mode</li>
								<li>Maze Navigation</li>
								<li>3-year warranty</li>
							</ul>
							<button
								onClick={() => navigate('/product/dolphin-S3000-pool-cleaner')}
								css={[
									tw`block bg-black hover:bg-gray-800 text-white text-sm md:text-base lg:text-lg font-semibold py-3 px-6 rounded-full transition-colors duration-200 mt-8 mx-auto md:mx-0 self-start`,
									{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 550, backgroundColor: '#221E1F' },
								]}
							>
								DISCOVER DOLPHIN S3000
							</button>
						</div>

						{/* S 3000 Image */}
						<div css={[tw`hidden md:block h-full`]}>
							<div css={[tw`rounded-[12px] md:rounded-[72px] overflow-hidden h-full`]}>
								<Img
									{...SLine3000Asset.nodes[0]}
									loading="lazy"
									style={{ height: '100%' }}
									imgStyle={{ objectFit: 'cover', width: '100%', height: '100%' }}
								/>
							</div>
						</div>
					</div>

					{/* S 2000 Grid */}
					<div css={[tw`grid md:grid-cols-2 gap-x-8 gap-y-6 md:gap-x-10 md:gap-y-14 lg:gap-x-12 lg:gap-y-16 mt-0 md:mt-16 max-w-6xl mx-auto items-stretch`]}>
						{/* S 2000 Image */}
						<div css={[tw`hidden md:block h-full flex`]}>
							<div css={[tw`rounded-lg md:rounded-[72px] h-full overflow-hidden`]}>
								<Img
									{...SLine2000Asset.nodes[0]}
									loading="lazy"
									css={[tw`h-full w-full object-cover rounded-lg md:rounded-[72px]`]}
								/>
							</div>
						</div>

						{/* S 2000 Content */}
						<div css={[tw`bg-white rounded-lg items-start text-center md:text-left md:pl-6 lg:pl-8`]}>
							<div css={[tw`block md:hidden rounded-[24px] overflow-hidden mb-4`]}>
								<Img
									{...SLine2000Asset.nodes[0]}
									loading="lazy"
									css={[tw`w-full h-full object-cover rounded-[24px]`]}
								/>
							</div>
							<div tw="flex justify-center md:justify-start mb-3">
								<img
									src={SLineS2000Logo.nodes[0].fluid.src}
									tw="w-auto h-full max-h-8 sm:max-h-10 md:max-h-12 lg:max-h-16 xl:max-h-20"
								/>
							</div>
							<p css={[tw`text-base md:text-lg lg:text-xl md:italic mt-3 mb-3 text-[#58C7DE]`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
								Best for smart convenience
							</p>
							<ul css={[tw`list-disc list-outside text-sm md:text-base lg:text-lg text-black text-left space-y-1.5 mx-auto md:mx-0`,
								{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 400, lineHeight: 1.1, paddingLeft: '1.25rem' }]}>
								<li>MyDolphin™ Plus app control</li>
								<li>Covers the Entire Pool - Floor, Walls, Waterline, Steps and Sun Ledge (min 30 cm)</li>
								<li>4 Cleaning Modes: Regular, Full Coverage, Floor Only & Fast Mode</li>
								<li>Interchangeable fine & ultra-fine filters</li>
								<li>Maze Navigation</li>
								<li>2-year warranty</li>
							</ul>
							<button
								onClick={() => navigate('/product/dolphin-S2000-pool-cleaner')}
								css={[
									tw`block bg-black hover:bg-gray-800 text-white text-sm md:text-base lg:text-lg font-semibold py-3 px-6 rounded-full transition-colors duration-200 mt-8 mx-auto md:mx-0 self-start`,
									{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 550, backgroundColor: '#221E1F' },
								]}
							>
								DISCOVER DOLPHIN S2000
							</button>

						</div>
					</div>

					{/* S 1000 Grid */}
					<div css={[tw`grid md:grid-cols-2 gap-x-8 gap-y-6 md:gap-x-10 md:gap-y-14 lg:gap-x-12 lg:gap-y-16 mt-10 md:mt-16 max-w-6xl mx-auto items-stretch`]}>
						{/* S 1000 Content */}
						<div css={[tw`bg-white rounded-lg items-start text-center md:text-left`]}>
							<div css={[tw`block md:hidden rounded-[24px] overflow-hidden mb-4`]}>
								<Img
									{...SLine1000Asset.nodes[0]}
									loading="lazy"
									css={[tw`w-full h-full object-cover rounded-[24px]`]}
								/>
							</div>
							<div tw="flex justify-center md:justify-start mb-3">
								<img
									src={SLineS1000Logo.nodes[0].fluid.src}
									tw="w-auto h-full max-h-8 sm:max-h-10 md:max-h-12 lg:max-h-16 xl:max-h-20"
								/>
							</div>
							<p css={[tw`text-base md:text-lg lg:text-xl md:italic mt-3 mb-3 text-[#58C7DE]`, { fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 800 }]}>
								Best for smart valve
							</p>
							<ul css={[tw`list-disc list-outside text-sm md:text-base lg:text-lg text-black text-left space-y-1.5 mx-auto md:mx-0`,
								{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 400, lineHeight: 1.1, paddingLeft: '1.25rem' }]}>
								<li>Covers the Entire Pool - Floor, Walls, Waterline, Steps and Sun Ledge (min 30 cm)</li>
								<li>Maze Navigation</li>
								<li>Top Access Fine Filter Basket</li>
								<li>2-year warranty</li>
							</ul>
							<button
								onClick={() => navigate('/product/dolphin-S1000-pool-cleaner')}
								css={[
									tw`block text-white text-sm md:text-base lg:text-lg font-semibold py-3 px-6 rounded-full transition-colors duration-200 mt-8 mx-auto md:mx-0 self-start`,
									{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 550, backgroundColor: '#221E1F' },
								]}
							>
								DISCOVER DOLPHIN S1000
							</button>
						</div>

						{/* S 1000 Image */}
						<div css={[tw`hidden md:block h-full flex`]}>
							<div css={[tw`rounded-[12px] md:rounded-[72px] h-full overflow-hidden`]}>
								<Img
									{...SLine1000Asset.nodes[0]}
									loading="lazy"
									css={[tw`h-full object-cover rounded-[12px] md:rounded-[72px]`]}
								/>
							</div>
						</div>
					</div>
				</div>

				{/* Compare the S Line section */}
				<div
					css={[
						tw`text-center px-12 md:px-20 lg:px-32 pt-8 pb-2 md:pt-12 md:pb-3 lg:pt-16 lg:pb-4 w-full`,
					]}
				>
					<div css={[tw`w-full overflow-x-auto`]}>
						<table
							css={[tw`w-full min-w-[700px] border-collapse`]}
						>
							<tr>
								<td> </td>
								<td css={[tw`py-4 px-2`]}>
									<Img
										{...SLine1000TableAsset.nodes[0]}
										loading="lazy"
										css={[tw`w-full`]}
									/>
									<div css={[tw`text-black font-bold py-2 text-center`]}>
										Dolphin S 1000
									</div>
								</td>
								<td css={[tw`py-4 px-4`]}>
									<Img
										{...SLine2000TableAsset.nodes[0]}
										loading="lazy"
										css={[tw`w-full`]}
									/>
									<div css={[tw`text-black font-bold py-2 text-center`]}>
										Dolphin S 2000
									</div>
								</td>
								<td css={[tw`py-4 px-4`]}>
									<Img
										{...SLine3000TableAsset.nodes[0]}
										loading="lazy"
										css={[tw`w-full`]}
									/>
									<div css={[tw`text-black font-bold py-2 text-center`]}>
										Dolphin S 3000
									</div>
								</td>
							</tr>

							{compareTableRowData.map((row, i) => {
								return <CompareTableRow key={i} {...row} />
							})}

							<tr>
								<td> </td>
								<td css={[tw`py-4`]}>
									<button
										css={[
											tw`bg-[#58C6DD] text-xs md:text-sm lg:text-base text-white px-6 py-2 rounded-full hover:bg-blue-300 transition`,
											{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 550, boxShadow: 'inset 0 4px 10px rgba(0,0,0,0.25)' },
										]}
										onClick={() => navigate('/product/dolphin-S1000-pool-cleaner')}
									>
										BUY NOW
									</button>
								</td>
								<td>
									<button
										css={[
											tw`bg-[#58C6DD] text-xs md:text-sm lg:text-base text-white px-6 py-2 rounded-full hover:bg-blue-300 transition`,
											{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 550, boxShadow: 'inset 0 4px 10px rgba(0,0,0,0.25)' },
										]}
										onClick={() => navigate('/product/dolphin-S2000-pool-cleaner')}
									>
										BUY NOW
									</button>
								</td>
								<td>
									<button
										css={[
											tw`bg-[#58C6DD] text-xs md:text-sm lg:text-base text-white px-6 py-2 rounded-full hover:bg-blue-300 transition`,
											{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 550, boxShadow: 'inset 0 4px 10px rgba(0, 0, 0, 0.25)' },
										]}
										onClick={() => navigate('/product/dolphin-S3000-pool-cleaner')}
									>
										BUY NOW
									</button>
								</td>
							</tr>
						</table>
					</div>

				</div>

				{/* S line Feature Assets section */}
				<div
					css={[
						tw`text-center px-4 pt-8 pb-2 md:pt-12 md:pb-3 lg:pt-16 lg:pb-4 mx-auto max-w-screen-lg w-full`,
					]}
				>
					{/* Image section */}
					<RoundedContainer css={[tw`text-center mt-8 md:mt-12 lg:mt-16 mx-auto w-full h-[400px]`]}>
						<Img
							{...SLineFeatureAsset1.nodes[0]}
							loading="lazy"
							css={[
								tw`h-full mx-auto`,
								css`
									img {
										object-fit: cover !important;
									}
								`,
							]}
						/>
					</RoundedContainer>

					<section
						css={[
							tw`py-2 grid lg:grid-cols-12 gap-4 lg:py-4 mx-auto mt-4 w-full`,
						]}
					>
						<RoundedContainer
							css={tw`
							object-cover w-full mx-auto items-center justify-center
							lg:col-span-7
							xl:col-span-7 h-[18rem] md:h-[24rem] shadow-xl`}
						>
							<Img
								{...SLineFeatureAsset2.nodes[0]}
								loading="lazy"
								css={[
									tw`w-full h-full mx-auto rounded-3xl`,
									css`
										img {
											object-fit: cover !important;
											object-position: 40% 70% !important;
										}
									`,
								]}
							/>
						</RoundedContainer>

						<RoundedContainer
							css={tw`
							object-cover w-full mx-auto items-center justify-center
							lg:col-span-5
							xl:col-span-5 h-[18rem] md:h-[24rem] shadow-xl`}
						>
							<Img
								{...SLineFeatureAsset3.nodes[0]}
								loading="lazy"
								css={[
									tw`w-full h-full mx-auto`,
									css`
										img {
											object-fit: cover !important;
										}
									`,
								]}
							/>
						</RoundedContainer>
					</section>
				</div>


				{ /* Final CTA Section */}
				<div css={tw`max-w-screen-lg px-8 pt-5 md:pt-10 pb-10 md:pb-20 mx-auto w-full text-center flex flex-col text-lg`}>
					<Img
						{...SLineLogoTagline.nodes[0]}
						loading="lazy"
						css={[
							tw`w-full h-auto mx-auto`,
							tw`max-w-xs md:max-w-md lg:max-w-lg xl:max-w-xl`,
						]}
					/>

					<div css={tw`flex justify-center gap-4 flex-wrap`}>
						<button
							onClick={() => navigate('/dolphin/s-line')}
							css={[
								tw`bg-black hover:bg-gray-800 text-white text-xs md:text-base lg:text-lg font-semibold py-3 px-6 rounded-full transition-colors duration-200`,
								{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 550, backgroundColor: '#221E1F' },
							]}
						>
							BUY NOW
						</button>

						<button
							onClick={() => navigate('/support/find-a-dealer/')}
							css={[
								tw`bg-black hover:bg-gray-800 text-white text-xs md:text-base lg:text-lg font-semibold py-3 px-6 rounded-full transition-colors duration-200`,
								{ fontFamily: 'Flexo, system-ui, sans-serif !important', fontWeight: 550, backgroundColor: '#221E1F' },
							]}
						>
							FIND A DEALER
						</button>
					</div>
				</div>
			</Layout>
		</div>
	)
}

/**
 * Page content query
 * @private
 * @static
 * @returns {() => void}
 */
export const SLinePageQuery = graphql`
	query SLinePageQuery {
		SLineHeroBanner: allContentfulAsset(
			filter: {
				contentful_id: { eq: "71tzJmLqvePyPF1mAzT1Eq" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 2000, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLineHeroBannerText: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5fk4toAAWuJNhkCsf14EXr" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		WhyChooseSLine01: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6W0bkQ1FLSzVFIYpERkCMy" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1620, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLine3000Asset: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6rHPEn89Umoi4o1etx4Ef9" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLine2000Asset: allContentfulAsset(
			filter: {
				contentful_id: { eq: "47bYATRbe1Y7Z5JOpXeMwr" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLine1000Asset: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6jZ6Z41qRGjhtyJ4KSqLlq" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLineS3000Logo: allContentfulAsset(
			filter: {
				contentful_id: { eq: "78f9S2bSelQIv34Xtorywd" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLineS2000Logo: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6I9TKHdb34FWns5ZtVbmTG" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLineS1000Logo: allContentfulAsset(
			filter: {
				contentful_id: { eq: "1Z584oirZtCjDEUDjx5RdG" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLine1000TableAsset: allContentfulAsset(
			filter: {
				contentful_id: { eq: "19dT1xjNosHv2tt0xclZRM" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLine2000TableAsset: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6knRKIgQZTNvcMov0GtOzr" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLine3000TableAsset: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6LeajaEzJuedYjgLxM5wLq" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLineFeatureAsset1: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5ljObV9wMvgoWHEwlpwNp5" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLineFeatureAsset2: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5GjeeKm371unOcoxuBeLqo" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLineFeatureAsset3: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6xIEHK6BB0xQE45H9lpFjk" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SLineLogoTagline: allContentfulAsset(
			filter: {
				contentful_id: { eq: "23Go4ZxUHWEuwlE0hVkJf2" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

		SlineGridImages: allContentfulAsset(
			filter: { contentful_id: { in: ["3h87tdtkyZaM0ZzeAXpM9Y", "5DvKfb4YHmK2eO2J2TaTRZ", "1ZDcdWmZ0Aom3fQkkIRdCn", "4149icRZvvCBDsV190mY6z"] } }
		) {
			nodes {
				contentful_id
				title
				description
				fluid(maxWidth: 600, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

	}
`

SLinePoolCleaner.propTypes = {
	props: PropTypes.shape({
		data: PropTypes.shape({
			SLineHeroBanner: PropTypes.object,
			SLineHeroBannerText: PropTypes.object,
			WhyChooseSLine01: PropTypes.object,
			SlineGridImages: PropTypes.object,
			SLine1000Asset: PropTypes.object,
			SLine2000Asset: PropTypes.object,
			SLine3000Asset: PropTypes.object,
			SLine1000TableAsset: PropTypes.object,
			SLine2000TableAsset: PropTypes.object,
			SLine3000TableAsset: PropTypes.object,
			SLineFeatureAsset1: PropTypes.object,
			SLineFeatureAsset2: PropTypes.object,
			SLineFeatureAsset3: PropTypes.object,
			SLineS3000Logo: PropTypes.object,
			SLineS2000Logo: PropTypes.object,
			SLineS1000Logo: PropTypes.object,
			SLineLogoTagline: PropTypes.object,
		}),
	}),
}

export default SLinePoolCleaner
